<template>
  <div :class="$b('')">
    <BaseCopy
      :class="$b('heading')"
      size="h4"
    >
      Related Content
    </BaseCopy>

    <ul :class="$b('articles-container')">
      <li
        v-for="article in articles"
        :key="article.id"
      >
        <VisionLink :to="resolveLocalePath(article.fullSlug)">
          <BaseCopy
            size="h4"
            :class="$b('title')"
          >
            {{ article.title }}
          </BaseCopy>
        </VisionLink>
        <BaseCopy
          v-if="showReadTime(article)"
          size="h4"
          :class="$b('read-time')"
        >
          {{ readTime(article) }}
        </BaseCopy>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'RelatedContent',

  props: {
    articles: {
      type: Array,
      default: () => [],
    },
  },

  setup() {
    const { resolveLocalePath } = useUrlBuilder()

    return { resolveLocalePath }
  },

  methods: {
    category(article) {
      return article.category && article.category.title
    },

    readTime(article) {
      const wordsPerMinute = 200
      const words = article.contentWordCounter
      const time = Math.ceil(words / wordsPerMinute)
      return `${time} minute read`
    },

    showReadTime(article) {
      const categories = ['Film']
      return (
        article.contentWordCounter &&
        !categories.includes(this.category(article))
      )
    },
  },
}
</script>

<style lang="postcss">
.RelatedContent__heading {
  @apply mb-[30px] underline;
}

.RelatedContent__articles-container {
  @apply space-y-sm md:max-w-[265px];
}

.RelatedContent__title,
.RelatedContent__read-time {
  @apply font-light leading-snug tracking-normal;
}

.RelatedContent__read-time {
  @apply text-grey-600;
}
</style>
